import React, { useEffect } from "react";
export interface SwitchDarkModeProps {
  className?: string;
}
const SwitchDarkMode: React.FC<SwitchDarkModeProps> = () => {

  useEffect(() => {
    const root = document.querySelector("html");
    if (!root) return;
    !root.classList.contains("dark") && root.classList.add("dark");
    localStorage.theme = "dark";
  }, []);

  return (
    <></>
  );
};

export default SwitchDarkMode;
